import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/Layout";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { formatUK } from "@/lib/format";
import { Loader2 } from "lucide-react";

const actionLabels = {
  company_created: "Company created", company_updated: "Company updated",
  shareholder_created: "Shareholder created", shareholder_updated: "Shareholder updated",
  shareholder_archived: "Shareholder archived", shareholder_unarchived: "Shareholder restored",
  dividend_created: "Dividend created", dividend_updated: "Dividend updated",
  dividend_finalised: "Dividend finalised", dividend_cancelled: "Dividend cancelled",
  dividend_superseded: "Dividend superseded", dividend_duplicated: "Dividend duplicated",
  voucher_downloaded: "Voucher downloaded", user_created: "User created", user_updated: "User updated",
};

export default function Audit() {
  const [logs, setLogs] = useState(null);
  useEffect(() => { api.get("/audit").then((r) => setLogs(r.data)); }, []);

  const fmtTime = (iso) => {
    const d = new Date(iso);
    return `${formatUK(iso)} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
  };

  return (
    <div data-testid="audit-page">
      <PageHeader title="Audit Trail" description="Immutable record of all key actions." />
      <Card className="border-cass-border shadow-sm">
        {logs === null ? <div className="flex h-40 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-cass-blue" /></div> : (
          <Table>
            <TableHeader>
              <TableRow className="bg-cass-surface hover:bg-cass-surface">
                <TableHead className="text-xs uppercase tracking-wider">Date & time</TableHead>
                <TableHead className="text-xs uppercase tracking-wider">User</TableHead>
                <TableHead className="text-xs uppercase tracking-wider">Action</TableHead>
                <TableHead className="text-xs uppercase tracking-wider">Details</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {logs.map((l) => (
                <TableRow key={l.id} className="hover:bg-cass-surface">
                  <TableCell className="whitespace-nowrap text-cass-navy/70 tabular">{fmtTime(l.timestamp)}</TableCell>
                  <TableCell className="text-cass-navy">{l.user_name}</TableCell>
                  <TableCell className="text-cass-navy/80">{actionLabels[l.action] || l.action}</TableCell>
                  <TableCell className="max-w-md truncate text-xs text-cass-navy/50">{l.new_value ? JSON.stringify(l.new_value) : "—"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Card>
    </div>
  );
}
